import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWafrMetric } from "../../../store/metric/actions";

export const useWafrData = () => {
  const dispatch = useDispatch();
  const wafrMetric = useSelector((state) => state.metricInfo.wafrMetric);
  const wafrMetricLoading = useSelector((state) => state.metricInfo.wafrMetricLoading);
  const wafrMetricError = useSelector((state) => state.metricInfo.wafrMetricError);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      dispatch(getWafrMetric());
      hasFetched.current = true;
    }
  }, [dispatch]);

  return { data: wafrMetric, loading: wafrMetricLoading, error: wafrMetricError };
}; 